import { getTotalYearsOfExperience } from "./commonFunctions";

export const prefilledDocData = (
  element,
  formData,
  candidateInformation,
  ocrData,
  ADDRESS,
  ZIP,
  designationDepartment
) => {
  element = {
    ...element,
    properties: JSON.parse(JSON.stringify(element.properties)),
  };

  if (element?.type === "select" && element?.parent.length !== 0) {
    element?.parent?.forEach((data) => {
      for (let i = 0; i < candidateInformation?.responses?.length; i++) {
        if (
          candidateInformation.responses[i].label ===
          data?.child?.properties.label
        ) {
          data.child.properties.value = candidateInformation.responses[i].value;
        }
        if (
          candidateInformation.responses[i].label === element.properties.label
        ) {
          element.properties.value = candidateInformation.responses[i].value;
        }
      }
    });
  } else if (
    element?.type === "statecity" ||
    element?.type === "departmentdesignation"
  ) {
    for (let i = 0; i < candidateInformation?.responses?.length; i++) {
      if (candidateInformation.responses[i].element.id === element.id) {
        if (element.type === "statecity") {
          let stateCity = {};
          if (candidateInformation.responses[i]?.label === "Select State") {
            stateCity.state = candidateInformation.responses[i].value;
          }
          if (candidateInformation.responses[i]?.label === "Select City") {
            stateCity.city = candidateInformation.responses[i].value;
          }
          if (
            candidateInformation.responses[i]?.label === "State And City" ||
            candidateInformation.responses[i]?.label === "State and City"
          ) {
            const valStr = String(candidateInformation.responses[i].value || "");
            if (valStr.includes("-")) {
              const parts = valStr.split("-").map((s) => s.trim());
              stateCity.state = stateCity.state || parts[0] || "";
              stateCity.city = stateCity.city || parts[1] || parts[0] || "";
            }
          }
          element.value = {
            state: stateCity?.state || (typeof candidateInformation.responses[i]?.value === "object" ? candidateInformation.responses[i]?.value?.state : candidateInformation.responses[i]?.value) || "",
            city: stateCity?.city || (typeof candidateInformation.responses[i]?.value === "object" ? candidateInformation.responses[i]?.value?.city : "") || "",
          };
        }
        if (element.type === "departmentdesignation") {
          if (
            candidateInformation.responses[i]?.label === "Select Designation"
          ) {
            designationDepartment.designation =
              candidateInformation.responses[i].value;
            designationDepartment.designationText =
              candidateInformation.responses[i].value;
          }

          if (
            candidateInformation.responses[i]?.label === "Select Department"
          ) {
            designationDepartment.department =
              candidateInformation.responses[i].value;
            designationDepartment.departmentText =
              candidateInformation.responses[i].value;
          }
          element.value = {
            department: designationDepartment?.department || "",
            departmentText: designationDepartment?.departmentText || "",
            designation: designationDepartment?.designation || "",
            designationText: designationDepartment?.designationText || "",
          };
        }
      }
    }
  } else {
    if (element.properties.label === "Correspondence address :") {
      element.properties.value = ADDRESS;
      element.comparison = ADDRESS?.trim()?.toLowerCase() || "";
    }

    if (element.properties.label === "Permanent Address:") {
      element.properties.value = ADDRESS;
      element.comparison = ADDRESS?.trim()?.toLowerCase() || "";
    }

    if (element.properties.label === "PIN Code") {
      element.properties.value = ZIP;
      element.comparison = ZIP?.trim()?.toLowerCase() || "";
    }

    for (let i = 0; i < candidateInformation?.responses?.length; i++) {
      if (
        candidateInformation.responses[i].label === element.properties.label
      ) {
        element.properties.value = candidateInformation.responses[i].value;
      }
      if (
        candidateInformation.responses[i].label === "professionalexperience"
      ) {
        element.value = candidateInformation.responses[i].value;
        element.filledOnly =
          candidateInformation.responses[i].element.filledOnly;
      }
    }

    if (formData?.formId?.name === "Bank Details") {
      const bankFile = formData?.files?.find(
        (file) => file?.fieldname === "Upload Cancelled Cheque"
      );

      if (element.properties.label === "Bank Account Number") {
        const bankAccountNumber =
          bankFile?.OCRData?.response?.account_number || "";
        element.comparison = bankAccountNumber?.trim()?.toLowerCase();
      }

      if (element.properties.label === "IFSC Code") {
        const bankIFSC = bankFile?.OCRData?.response?.ifsc_code || "";
        element.comparison = bankIFSC?.trim()?.toLowerCase();
      }

      if (element.properties.label === "Bank Name") {
        const bankName = bankFile?.OCRData?.response?.bank_name || "";
        element.comparison = bankName?.trim()?.toLowerCase();
      }
    }

    if (formData?.formId?.name === "Candidate Information Form") {
      if (element.properties.label === "Select caste category.") {
        const cc = formData?.files?.find(
          (file) => file?.fieldname === "Upload Caste Certificate"
        );

        let caste = "";

        if (cc?.OCRData?.response?.category) {
          caste =
            element?.properties?.options?.find((ele) =>
              ele
                ?.toLowerCase()
                ?.trim()
                ?.includes(
                  cc?.OCRData?.response?.category?.trim().toLowerCase()
                )
            ) || "Others";
        }
        element.comparison = caste;
      }

      if (element.properties.label === "Blood Group") {
        const bg = formData?.files?.find(
          (file) => file?.fieldname === "Upload Blood group"
        );
        const blood_group = bg?.OCRData?.response?.blood_group || "";
        element.comparison = blood_group?.trim()?.toLowerCase();
      }

      if (element.properties.label === "Father's Name") {
        const th12 = formData?.files?.find(
          (file) => file?.fieldname === "Upload 12th Certificate"
        );

        const th10 = formData?.files?.find(
          (file) => file?.fieldname === "Upload 10th Certificate"
        );

        const fatherName =
          th12?.OCRData?.response?.father_name ||
          th10?.OCRData?.response?.father_name ||
          "";
        element.comparison = fatherName?.trim()?.toLowerCase();
      }

      if (element.properties.label === "Mother's Name") {
        const th12 = formData?.files?.find(
          (file) => file?.fieldname === "Upload 12th Certificate"
        );

        const th10 = formData?.files?.find(
          (file) => file?.fieldname === "Upload 10th Certificate"
        );

        const fatherName =
          th12?.OCRData?.response?.mother_name ||
          th10?.OCRData?.response?.mother_name ||
          "";
        element.comparison = fatherName?.trim()?.toLowerCase();
      }

      if (element.properties.label === "Highest qualification") {
        const pg = formData?.files?.find(
          (file) => file?.fieldname === "Upload Postgraduate Certificate"
        );

        const gc = formData?.files?.find(
          (file) => file?.fieldname === "Upload Graduation Certificate"
        );

        const th12 = formData?.files?.find(
          (file) => file?.fieldname === "Upload 12th Certificate"
        );

        const th10 = formData?.files?.find(
          (file) => file?.fieldname === "Upload 10th Certificate"
        );
        let data = "";
        if (
          pg?.OCRData?.response?.status ||
          gc?.OCRData?.response?.status ||
          th12?.OCRData?.response?.status ||
          th10?.OCRData?.response?.status
        ) {
          const qualifications = [
            {
              match: pg?.OCRData?.response,
              key: "Post Graduate",
            },
            {
              match: gc?.OCRData?.response,
              key: "Graduate",
            },
            {
              match: th12?.OCRData?.response,
              key: "12th",
            },
            {
              match: th10?.OCRData?.response,
              key: "10th",
            },
          ];
          const highestQualificationIndex = qualifications.findIndex(
            (ele) => ele?.match && ele?.match?.status?.toLowerCase() === "pass"
          );
          const highestQualification =
            highestQualificationIndex !== -1
              ? qualifications[highestQualificationIndex]
              : undefined;
          data = highestQualification?.key || "";
        }
        element.comparison = data?.trim()?.toLowerCase();
      }
    }

    if (formData?.formId?.name === "Bank Details" && ocrData) {
      if (
        element.properties.label === "Bank Account Number" &&
        ocrData?.cancelCheque
      ) {
        const bankAccountNumber = ocrData?.cancelCheque?.account_number || "";
        const formValue = candidateInformation.responses?.find(
          (ele) => ele?.label === "Bank Account Number"
        );
        element.properties.value = ocrData?.cancelCheque?.isActive
          ? bankAccountNumber
          : formValue?.value;
      }

      if (element.properties.label === "IFSC Code" && ocrData?.cancelCheque) {
        const bankIFSC = ocrData?.cancelCheque?.ifsc_code || "";
        const formValue = candidateInformation.responses?.find(
          (ele) => ele?.label === "IFSC Code"
        );
        element.properties.value = ocrData?.cancelCheque?.isActive
          ? bankIFSC
          : formValue?.value;
      }

      if (element.properties.label === "Bank Name" && ocrData?.cancelCheque) {
        const bankName = ocrData?.cancelCheque?.bank_name || "";
        const formValue = candidateInformation.responses?.find(
          (ele) => ele?.label === "Bank Name"
        );
        element.properties.value = ocrData?.cancelCheque?.isActive
          ? bankName
          : formValue?.value;
      }
    }

    if (formData?.formId?.name === "Candidate Information Form" && ocrData) {
      if (
        element.properties.label === "Select caste category." &&
        ocrData?.casteCertificate
      ) {
        const caste =
          element?.properties?.options?.find((ele) =>
            ele
              ?.toLowerCase()
              ?.trim()
              ?.includes(
                ocrData?.casteCertificate?.category?.trim().toLowerCase()
              )
          ) || "Others";
        const formValue = candidateInformation.responses?.find(
          (ele) => ele?.label === "Select caste category."
        );
        element.properties.value = ocrData?.casteCertificate?.isActive
          ? caste
          : formValue?.value;
      }

      if (element.properties.label === "Blood Group" && ocrData?.bloodGroup) {
        const bloodGroup = ocrData?.bloodGroup?.blood_group || "";
        const formValue = candidateInformation.responses?.find(
          (ele) => ele?.label === "Blood Group"
        );
        element.properties.value = ocrData?.bloodGroup?.isActive
          ? bloodGroup
          : formValue?.value;
      }

      if (
        element.properties.label === "Father's Name" &&
        (ocrData?.twelfthCertificate || ocrData?.tenthCertificate)
      ) {
        const father_name =
          ocrData?.twelfthCertificate?.father_name ||
          ocrData?.tenthCertificate?.father_name ||
          "";
        const formValue = candidateInformation.responses?.find(
          (ele) => ele?.label === "Father's Name"
        );

        if (ocrData?.tenthCertificate?.isActive) {
          element.properties.value = ocrData?.tenthCertificate?.isActive
            ? father_name
            : formValue?.value;
        }

        if (ocrData?.twelfthCertificate?.isActive) {
          element.properties.value = ocrData?.twelfthCertificate?.isActive
            ? father_name
            : formValue?.value;
        }
      }

      if (
        element.properties.label === "Mother's Name" &&
        (ocrData?.twelfthCertificate || ocrData?.tenthCertificate)
      ) {
        const mother_name =
          ocrData?.twelfthCertificate?.mother_name ||
          ocrData?.tenthCertificate?.mother_name ||
          "";
        const formValue = candidateInformation.responses?.find(
          (ele) => ele?.label === "Mother's Name"
        );

        if (ocrData?.tenthCertificate?.isActive) {
          element.properties.value = ocrData?.tenthCertificate?.isActive
            ? mother_name
            : formValue?.value;
        }

        if (ocrData?.twelfthCertificate?.isActive) {
          element.properties.value = ocrData?.twelfthCertificate?.isActive
            ? mother_name
            : formValue?.value;
        }
      }

      if (
        element.properties.label === "Highest qualification" &&
        (ocrData?.postGraduationCertificate ||
          ocrData?.graduationCertificate ||
          ocrData?.twelfthCertificate ||
          ocrData?.tenthCertificate)
      ) {
        const qualifications = [
          {
            match: ocrData?.postGraduationCertificate,
            key: "Post Graduate",
          },
          {
            match: ocrData?.graduationCertificate,
            key: "Graduate",
          },
          { match: ocrData?.twelfthCertificate, key: "12th" },
          { match: ocrData?.tenthCertificate, key: "10th" },
        ];
        const highestQualificationIndex = qualifications.findIndex(
          (ele) => ele?.match && ele?.match?.status?.toLowerCase() === "pass"
        );
        const highestQualification =
          highestQualificationIndex !== -1
            ? qualifications[highestQualificationIndex]
            : undefined;
        const data = highestQualification?.key || "";
        const formValue = candidateInformation.responses?.find(
          (ele) => ele?.label === "Highest qualification"
        );

        if (ocrData?.tenthCertificate?.isActive) {
          element.properties.value = ocrData?.tenthCertificate?.isActive
            ? data || ""
            : formValue?.value;
        }

        if (ocrData?.twelfthCertificate?.isActive) {
          element.properties.value = ocrData?.twelfthCertificate?.isActive
            ? data || ""
            : formValue?.value;
        }

        if (ocrData?.graduationCertificate?.isActive) {
          element.properties.value = ocrData?.graduationCertificate?.isActive
            ? data || ""
            : formValue?.value;
        }
        if (ocrData?.postGraduationCertificate?.isActive) {
          element.properties.value = ocrData?.postGraduationCertificate
            ?.isActive
            ? data || ""
            : formValue?.value;
        }
      }
    }

    if (formData?.formId?.name === "Professional Experience" && ocrData) {
      if (
        element.properties.label === "Total experience in month" &&
        ocrData?.experienceLetter
      ) {
        const formValue = candidateInformation.responses?.find(
          (ele) => ele?.label === "Total experience in month"
        );
        const total_exp = ocrData?.experienceLetter?.total_exp_in_months || "";
        element.properties.value = ocrData?.experienceLetter?.isActive
          ? total_exp
          : formValue?.value;
        element.comparison = total_exp?.trim().toLowerCase();
      }
      element.ocrData = ocrData;
    }
  }
  return element;
};
